import React from 'react';

import { useRouter } from 'expo-router';
import { Linking } from 'react-native';

import ActionButton from 'components/action-button';
import { isExternalLink } from 'utils/is-external-link';

import {
  CallToAction,
  CallToActionBody,
  CallToActionHeaderContainer,
  CallToActionHeading,
  CallToActionSubheading,
  CallsToAction,
  Image,
} from './styled';
import { CallToActionWidgetProps } from './types';

export const CallToActionWidget = (props: CallToActionWidgetProps) => {
  const { navigate } = useRouter();
  const navigateToUrl = (url: string) => {
    if (isExternalLink(url)) {
      Linking.openURL(url);
    } else {
      navigate(url);
    }
  };

  return (
    <CallsToAction>
      {props.callToActionContent.map((cta, index) => {
        return (
          <CallToAction key={index}>
            {cta.image && <Image objectFitContain image={cta.image?.locale} alt="" />}
            <CallToActionHeaderContainer>
              {cta.heading && <CallToActionHeading>{cta.heading?.locale}</CallToActionHeading>}
              {cta.subheading?.locale && (
                <CallToActionSubheading>{cta.subheading?.locale}</CallToActionSubheading>
              )}
              {cta.body && <CallToActionBody>{cta.body?.locale}</CallToActionBody>}
              {cta.buttonText && (
                <ActionButton
                  fullWidth
                  variant={'solid' as any}
                  color="primary"
                  onPress={() => navigateToUrl(cta.link?.locale || '')}
                >
                  {cta.buttonText?.locale}
                </ActionButton>
              )}
            </CallToActionHeaderContainer>
          </CallToAction>
        );
      })}
    </CallsToAction>
  );
};
